import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  connectOutlook,
  disconnectCalendar,
  getCalendar,
  getOutlookCalendars,
} from "store/actions"
import SyncOutlookConflictsModal from "./syncOutlookConflictsModal"
import SyncOutlookAddModal from "./syncOutlookAddModal"

const ConnectCalendarTab = ({
  selectedCalendar,
  connectOutlook,
  disconnectCalendar,
  getCalendar,
  getOutlookCalendars,
  outlookCalendars,
}) => {
  const [outlookConflictsModalIsOpen, setOutlookConflictsModalIsOpen] =
    useState(false)
  const [outlookAddCalendarsModalIsOpen, setOutlookAddCalendarsModalIsOpen] =
    useState(false)

  useEffect(() => {
    if (selectedCalendar && selectedCalendar?.outlook_connection) {
      getOutlookCalendars({
        type: "outlook",
        calendar_id: selectedCalendar?.id,
      })
    }
  }, [selectedCalendar])

  return (
    <React.Fragment>
      <Card className="mt-3">
        <CardHeader>
          <h4>SET CONNECTION</h4>
        </CardHeader>
        <CardBody>
          {!selectedCalendar && (
            <Row className="mb-3">
              <Col xs="auto">
                <i className="bx bx-info-circle font-size-22 me-2" />
                <span style={{ verticalAlign: "super" }}>
                  You have to first create the calendar and then you will able
                  to connect it.
                </span>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs="auto" className="mt-2">
              <label>Google Calendar:</label>
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Connect"
                disabled={!selectedCalendar}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs="auto" className="mt-2">
              <label>Outlook Calendar:</label>
            </Col>
            {!selectedCalendar?.outlook_connection && (
              <Col xs="auto">
                <SaveButton
                  type="button"
                  content={"Connect"}
                  disabled={!selectedCalendar}
                  onClick={() => {
                    connectOutlook({ calendar_id: selectedCalendar?.id })
                  }}
                />
              </Col>
            )}
          </Row>
          {!!selectedCalendar?.outlook_connection && (
            <React.Fragment>
              <Row>
                <Col xs="auto">
                  <span>
                    {selectedCalendar?.outlook_connection?.outlook_email}
                  </span>{" "}
                </Col>
                <Col xs="auto">
                  <span
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      disconnectCalendar({
                        calendar_id: selectedCalendar?.id,
                        type: "outlook",
                        callback: () =>
                          getCalendar({ id: selectedCalendar?.id }),
                      })
                    }}
                  >
                    Disconnect
                  </span>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <h5>Configuration</h5>
                </Col>
              </Row>
              {outlookCalendars?.length > 0 ? (
                <React.Fragment>
                  <Row className="mt-2 mb-3">
                    <Col xl={6}>
                      <span>
                        <b>Check for conflicts</b>
                      </span>
                      <br />
                      <span>
                        Set the calendar(s) to check for conflicts to prevent
                        double bookings.
                      </span>
                    </Col>
                    <Col className="align-self-center">
                      <Row>
                        <Col xs="auto">
                          {selectedCalendar?.outlook_sync_calendars_conflicts
                            ?.length === 0 ? (
                            <span>No calendar selected</span>
                          ) : (
                            <ul className="m-0">
                              {selectedCalendar?.outlook_sync_calendars_conflicts?.map(
                                (x, index) => (
                                  <li key={index}>
                                    {
                                      outlookCalendars?.find(
                                        y => y?.id === x?.external_calendar_id
                                      )?.summary
                                    }
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                        </Col>
                        <Col className="align-self-center">
                          <span
                            className="text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={() => setOutlookConflictsModalIsOpen(true)}
                          >
                            edit
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <hr className="my-0" />
                  <Row className="mt-2">
                    <Col xl={6}>
                      <span>
                        <b>Add to calendar</b>
                      </span>
                      <br />
                      <span>
                        Set the calendar you would like to add new bookings to
                        as they’re scheduled.
                      </span>
                    </Col>
                    <Col className="align-self-center">
                      <Row>
                        <Col xs="auto" className="align-self-center">
                          {selectedCalendar?.outlook_sync_calendars_add
                            ?.length === 0 ? (
                            <span>No calendar selected</span>
                          ) : (
                            <ul className="m-0">
                              {selectedCalendar?.outlook_sync_calendars_add?.map(
                                (x, index) => (
                                  <li key={index}>
                                    {
                                      outlookCalendars?.find(
                                        y => y?.id === x?.external_calendar_id
                                      )?.summary
                                    }
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                        </Col>
                        <Col className="align-self-center">
                          <span
                            className="text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setOutlookAddCalendarsModalIsOpen(true)
                            }
                          >
                            edit
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </React.Fragment>
              ) : (
                <span>
                  You have no calendars on the connected Outlook account!
                </span>
              )}
            </React.Fragment>
          )}
        </CardBody>
      </Card>
      <ModalComponent
        title={`How should we check for conflicts for calendar "${selectedCalendar?.name}"?`}
        open={outlookConflictsModalIsOpen}
        onClose={() => setOutlookConflictsModalIsOpen(false)}
        size="lg"
      >
        <SyncOutlookConflictsModal
          calendar={selectedCalendar}
          onClose={() => setOutlookConflictsModalIsOpen(false)}
          outlookCalendars={outlookCalendars}
        />
      </ModalComponent>
      <ModalComponent
        title={`Which calendar should we add new events from calendar "${selectedCalendar?.name}"?`}
        open={outlookAddCalendarsModalIsOpen}
        onClose={() => setOutlookAddCalendarsModalIsOpen(false)}
        size="lg"
      >
        <SyncOutlookAddModal
          calendar={selectedCalendar}
          onClose={() => setOutlookAddCalendarsModalIsOpen(false)}
          outlookCalendars={outlookCalendars}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  selectedCalendar: state.BookingsFeature.selectedCalendar,
  outlookCalendars: state.BookingsFeature.outlookCalendars,
})

const mapDispatchToProps = dispatch => ({
  connectOutlook: values => dispatch(connectOutlook(values)),
  disconnectCalendar: values => dispatch(disconnectCalendar(values)),
  getCalendar: values => dispatch(getCalendar(values)),
  getOutlookCalendars: values => dispatch(getOutlookCalendars(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ConnectCalendarTab)
